import React from 'react';
import { useTranslation } from 'react-i18next';
import { NewBMStep4SC, StepDescription, ServerSizeGrid, NewBMStep4SContainer } from './NewBMStep4.style';
import ManagedPlanCard from 'components/bm-deployment/managed-plan-card/ManagedPlanCard';
import FormikErrorMessage from 'components/formik-error-message';
import Heading from 'components/Heading/Heading';

const NewVMStep4 = ({ withPricing, selectedManagedPlan, onManagedPlanSelection, formikProp }) => {
  const { t } = useTranslation();
  return (
    <NewBMStep4SC>
      <NewBMStep4SContainer>
        <Heading name={'bm/instance/create.step4_string2'}>
          <StepDescription>
            {t('bm/instance/create.step4_string3')}
            <br />
            <br />
            {t('bm/instance/create.step4_string4')}
          </StepDescription>
          <ServerSizeGrid>
            {withPricing?.map((plan) => (
              <ManagedPlanCard
                key={plan.id}
                data={plan}
                selected={plan.id === selectedManagedPlan}
                onClick={onManagedPlanSelection}
              />
            ))}
          </ServerSizeGrid>
        </Heading>
      </NewBMStep4SContainer>
      <FormikErrorMessage value="managed_plan" formikProp={formikProp} />
    </NewBMStep4SC>
  );
};
export default NewVMStep4;
